import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { ClearCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, ResetData } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { removeFromCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = Handler<
    {
        /**
         * @deprecated this is not supported. It is here to prevent build errors because previously it could be passed in without causing a failure.
         */
        cartId?: string;
    },
    {
        apiParameter: ClearCartApiParameter;
    }
>;

export const TriggerRemoveFromCartEvent: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const itemData = [];
    if (cart?.cartLines && cart.cartLines.length) {
        for (let i = 0; i < cart.cartLines.length; i++) {
            itemData.push({
                item_id: cart?.cartLines[i].erpNumber,
                item_name: cart?.cartLines[i].shortDescription,
                item_brand: cart?.cartLines[i].brand?.name ? cart?.cartLines[i].brand?.name : "",
                price: cart?.cartLines[i].pricing?.actualPrice,
                quantity: cart?.cartLines[i].qtyOrdered
            })
        }
    }
    removeFromCartEvent({
        event: "remove_from_cart",
        ecommerce: {
            value: cart?.orderSubTotal ?? 0,
            currency: "USD",
            items: itemData
        }
    });
};

addToChainAfter(chain, ResetData, TriggerRemoveFromCartEvent);